import { Link } from 'react-router-dom';
import SvgAnimation from '../../../hooks/SvgAnimation';
import BtnArrow from '../../../svg/BtnArrow';

const Banner = () => {

   const svgIconRef = SvgAnimation('/assets/img/objects/title_shape.svg');

   return (
      <section
         className="banner-area banner-bg tg-motion-effects"
         style={{ backgroundImage: `url(/assets/img/banner/banner_bg.png)` }}
      >
         <div className="container">
            <div className="row justify-content-between align-items-start">
               <div className="col-xl-6 col-lg-6">
                  <div className="banner__content">
                  <h3 className="title tg-svg" data-aos="fade-right" data-aos-delay="400" ref={svgIconRef}>
  Master IT Skills, <br /> Build
  <span className="position-relative" style={{ marginLeft: "10px", display: "inline-block" }}>
    <span className="svg-icon"></span>
    <svg
      x="0px"
      y="0px"
      width="260px"  // Increased width
      height="65px"  // Increased height
      preserveAspectRatio="none"
      viewBox="0 0 260 65" // Adjusted viewBox for proper scaling
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        position: "absolute",
        left: "10",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: "-1"
      }}
    >
      <path
        d="M4 7C80 -1 170 -2 250 4C255 4.5 260 7 260 10C257 25 255 40 253 55C253 58 250 60 245 60C180 65 90 67 10 60C7 59 4 57 3 53C1 40 -1 25 -3 10C-4 5 2 5 4 7"
        fill="orange"
      />
    </svg>
    <span style={{ position: "relative", zIndex: "1" }}>Real-World Projects</span>
  </span>
  <br />
  Get <b>Job Ready</b>
</h3>

                     <p data-aos="fade-right" data-aos-delay="600">
                     Join hands-on training with an industry expert. Gain practical experience, showcase real projects, and accelerate your career
                     </p>
                     <div className="banner__btn-wrap" data-aos="fade-right" data-aos-delay="800">
                        <Link to="/courses" className="btn arrow-btn">
                        Start Your Journey Today <BtnArrow />
                        </Link>
                     </div>
                  </div>
               </div>

               <div className="col-lg-6">
                  <div className="banner__images">
<div style={{ maxWidth: '450px', marginLeft: '120px' }}>
  <img 
    src="/assets/img/banner_2.png" 
    alt="img"
    style={{ width: '100%', height: 'auto' }}
  />
</div>




                     <div className="shape big-shape" data-aos="fade-up-right" data-aos-delay="600">
                        <img src="/assets/img/banner/banner_shape01.png" alt="shape" className="tg-motion-effects1" />
                     </div>
                     <img src="/assets/img/banner/bg_dots.svg" alt="shape" className="shape bg-dots rotateme" />
                     <img src="/assets/img/banner/banner_shape02.png" alt="shape" className="shape small-shape tg-motion-effects3" />
                     {/* <div className="banner__author">
                        <div className="banner__author-item">
                           <div className="image">
                              <img src="/assets/img/banner/banner_author02.png" alt="img" />
                           </div>
                           <h6 className="name">Mohan</h6>
                        </div>
                        <div className="banner__author-item">
                           <div className="image">
                              <img src="/assets/img/banner/banner_author02.png" alt="img" />
                           </div>
                           <h6 className="name">Samarth</h6>
                        </div>
                        <img src="/assets/img/banner/banner_shape02.svg" alt="shape" className="arrow-shape tg-motion-effects3" />
                     </div> */}
                  </div>
               </div>
            </div>
         </div>
         <img src="/assets/img/banner/banner_shape01.svg" alt="shape" className="line-shape" data-aos="fade-right" data-aos-delay="1600" />
      </section>
   );
};

export default Banner;
